import type { MessageHandler, MessageType } from './types';

export class MessageHandlerRegistry {
  private readonly handlers = new Map<MessageType, MessageHandler[]>();
  private readonly defaultTtls = new Map<MessageType, number>();

  register(type: MessageType, handler: MessageHandler) {
    const existing = this.handlers.get(type) ?? [];
    existing.push(handler);
    this.handlers.set(type, existing);
  }

  configure(type: MessageType, options: { ttl: number }) {
    if (this.defaultTtls.has(type) && __DEV__ && this.defaultTtls.get(type) !== options.ttl) {
      console.warn(`[messagesBus] Conflicting defaultTtl for ${type}`);
    }
    this.defaultTtls.set(type, options.ttl);
  }

  getAll(type: MessageType): MessageHandler[] {
    return this.handlers.get(type) ?? [];
  }

  getDefaultTtl(type: MessageType): number | undefined {
    return this.defaultTtls.get(type);
  }

  reset() {
    this.handlers.clear();
    this.defaultTtls.clear();
  }
}

export const messageHandlerRegistry = new MessageHandlerRegistry();
